import React, { useState, useRef, useEffect } from 'react';
import './SecRowGallery.css';
import PreviewButton from './PreviewButton'; // Import the PreviewButton component

const SecRowGallery = () => {
  const [activeCard, setActiveCard] = useState(null);
  const [animeList, setAnimeList] = useState([]); // Store fetched anime list
  const [previewAnimeId, setPreviewAnimeId] = useState(null); // Store anime ID for PreviewButton modal
  const galleryRef = useRef(null); // Reference to the gallery container

  const handleCardClick = (card) => {
    setActiveCard(card === activeCard ? null : card); // Toggle active state on click
  };

  const scroll = (direction) => {
    const gallery = galleryRef.current;
    const scrollAmount = direction === 'left' ? -300 : 300;
    gallery.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  };

  // Fetch the top anime list when the component mounts
  useEffect(() => {
    const fetchAnimeList = async () => {
      try {
        const response = await fetch('https://api.jikan.moe/v4/top/anime'); // Fetch top anime
        const data = await response.json();
        const animeList = data.data.map((anime) => ({
          id: anime.mal_id,
          title: anime.title,
          image: anime.images.jpg.image_url, // Get anime poster image
        }));
        setAnimeList(animeList); // Store the fetched anime list
      } catch (error) {
        console.error('Error fetching anime list:', error);
      }
    };

    fetchAnimeList();
  }, []);

  // Open the PreviewButton modal
  const handlePreviewClick = (animeId) => {
    setPreviewAnimeId(animeId); // Pass the anime ID to PreviewButton
  };

  // Close the PreviewButton modal
  const closePreview = () => {
    setPreviewAnimeId(null); // Reset the anime ID to close the modal
  };

  return (
    <div className="SecRowGallery-container">
      {/* Left arrow */}
      <div
        className="SecRowGallery-arrow left"
        onClick={() => scroll('left')}
      >
        <span>&#8592;</span>
      </div>

      {/* Gallery container */}
      <div className="SecRowGallery-cards" ref={galleryRef}>
        {/* Dynamically render anime cards */}
        {animeList.map((anime) => (
          <div
            key={anime.id}
            className={`SecRowGallery-card card-${anime.id} ${activeCard === anime.id ? 'active' : ''}`}
            onClick={() => handleCardClick(anime.id)}
          >
            <img src={anime.image} alt={anime.title} className="SecRowGallery-image" />
            <div className={`SecRowGallery-card-info ${activeCard === anime.id ? 'show' : ''}`}>
              <h3>{anime.title}</h3>
              <button 
                className="SecRowGallery-btn"
                onClick={() => handlePreviewClick(anime.id)} // Open PreviewButton modal
              >
                Preview
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Right arrow */}
      <div
        className="SecRowGallery-arrow right"
        onClick={() => scroll('right')}
      >
        <span>&#8594;</span>
      </div>

      {/* Render PreviewButton modal if anime is selected */}
      {previewAnimeId && (
        <PreviewButton animeId={previewAnimeId} onClose={closePreview} />
      )}
    </div>
  );
};

export default SecRowGallery;
